
import Common from '@/mixins/common'
import Notice from '../../components/Notice.vue'
import { ModalConfirmProps, NoticeProps } from "@/scripts/datatypes"
import {SchoolPrivateProfile, } from "../../common-datatypes"
import { DocumentReference, getDocs, onSnapshot, query, where} from "firebase/firestore"
import { ValidationObserver } from 'vee-validate'
import { Component, Mixins} from "vue-property-decorator"
import Confirm from "@/components/ModalConfirm.vue"
//import { ValidationFlags } from 'vee-validate/dist/types/types';

@Component({
  components: {
    Notice,
    Confirm
  }
})

export default class LineLinkSettings extends Mixins(Common) {
  isLoading = false
  channelAccessToken = ''
  channelSecret =  ''
  schoolLineUserId = ''
  showModal = false
  notice = {} as NoticeProps

  observer = {} as InstanceType<typeof ValidationObserver>

  get isDisabled(){
    if(this.schoolLineUserId){
      return true
    }

    if(this.channelAccessToken && this.channelSecret){
      return false
    }
    return true
  }

  resetSchoolLineAccountConfirmProps: ModalConfirmProps = {
    isShow: false,
    title: 'lineLinkSettings.reset',
    message: 'lineLinkSettings.resetDescription',
    isLoading: false,
  }

  resetAllUserLineAccountConfirmProps: ModalConfirmProps = {
    isShow: false,
    title: 'lineLinkSettings.resetAllUser',
    message: 'lineLinkSettings.resetAllUserDescription',
    isLoading: false,
  }

  schoolPrivateProfileData = {} as SchoolPrivateProfile

  updated(){
    if(! this.observer.flags && this.$refs.validationObserver){
      this.observer = this.$refs.validationObserver as InstanceType<typeof ValidationObserver>
    }
  }

  get accountName(){
    return this.$store.state.school.lineAccount ? this.$store.state.school.lineAccount.displayName as string : ''
  }


  created(){
    console.trace('created');

    const schoolPrivateProfileDocRef = this.$getSchoolPrivateProfileDocRef()

    onSnapshot(schoolPrivateProfileDocRef, (doc) => {
      this.schoolPrivateProfileData = doc.data() as SchoolPrivateProfile
      if(this.schoolPrivateProfileData.lineAccount){
        this.schoolLineUserId = this.schoolPrivateProfileData.lineAccount.userId
        this.channelAccessToken = this.schoolPrivateProfileData.lineAccount.channelAccessToken
        this.channelSecret = this.schoolPrivateProfileData.lineAccount.channelSecret
      }
      if(this.observer && 'reset' in this.observer){
        this.observer.reset()
      }
    })
  }
 
 async mounted(){
  console.trace('mounted')
 }

  destroyed() {
    console.trace('destroyed');
  }

  resetSchoolLineAccountConfirm(event: boolean){
    if(event){
      this.resetLineAccountSetting()
    }else{
      this.resetSchoolLineAccountConfirmProps.isShow = false
    }    
  }

  resetAllUserLineAccountConfirm(event: boolean){
    if(event){
      this.resetAllUserLineAccount()
    }else{
      this.resetAllUserLineAccountConfirmProps.isShow = false
    }    
  }

  async resetAllUserLineAccount(){
    this.$store.commit("setLoading",true);
    this.isLoading = true

    try{
      this.resetAllUserLineAccountConfirmProps.isLoading = true

      const usersPrivateProfileQuery = query(this.$getUsersPrivateProfileQuery(),where('lineUserId','!=', ''))

      const usersPrivateProfileDocs = await getDocs(usersPrivateProfileQuery)

      const resetLineLinkageUsersDocRef: Array<DocumentReference> = []
      const resetLineLinkageUsersDocData: Array<{lineUserId: ''}> = []
      
      usersPrivateProfileDocs.docs.map((doc) => {
        resetLineLinkageUsersDocRef.push(doc.ref)
        resetLineLinkageUsersDocData.push({lineUserId: ''})
      })

      await this.$updateDocs(resetLineLinkageUsersDocRef, resetLineLinkageUsersDocData)

      this.notice = {
        message: 'lineLinkSettings.success',
        duration: 0,
        isShow: true,
        type: {'is-success': true}
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('lineLinkSettings.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.resetAllUserLineAccountConfirmProps.isLoading = false
      this.resetAllUserLineAccountConfirmProps.isShow = false
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
   
  }

  async resetLineAccountSetting(){
    this.$store.commit("setLoading",true);
    this.isLoading = true

    try{
      this.resetSchoolLineAccountConfirmProps.isLoading = true

      await this.$resetLineHook({
        schoolId: this.$store.getters.schoolId,
      })

      this.notice = {
        message: 'lineLinkSettings.success',
        duration: 0,
        isShow: true,
        type: {'is-success': true}
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('lineLinkSettings.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.resetSchoolLineAccountConfirmProps.isLoading = false
      this.resetSchoolLineAccountConfirmProps.isShow = false
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  public async settings() {
    try{
      this.notice = {
        isShow: false,
      }

      if(await this.observer.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true

        await this.$setUpLineHook({
          schoolId: this.$store.getters.schoolId,
          channelAccessToken: this.channelAccessToken,
          channelSecret: this.channelSecret
        })

        this.notice = {
          message: 'lineLinkSettings.success',
          duration: 0,
          isShow: true,
          type: {'is-success': true}
        }
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('lineLinkSettings.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
